// Trick VH for mobile Devices
let vh = window.innerHeight * 0.01;

let setVHSize = () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

document.addEventListener('DOMContentLoaded', setVHSize);
window.addEventListener('resize', setVHSize);

// Navtoggler

document.querySelector('.header__navtoggler').addEventListener('click', () => {
  document.body.classList.toggle('body--activenav');
  document.querySelector('.header').classList.toggle('header--inverted');
})

// Offcanvas Functionality
for (let parentMenuItem of document.querySelectorAll('.header__navigation ul li.parent')) {
  parentMenuItem.querySelector('a, span').addEventListener('click', (e) => {
    if (window.innerWidth < 1200) {
      e.preventDefault();
      parentMenuItem.classList.toggle('expanded');
    }
  })
}

// Check if scrolled to change styling for fixed elements

window.addEventListener('scroll', () => {
  if(window.scrollY > 0) {
    document.querySelector('body').classList.add('body--scrolled')
  } else {
    document.querySelector('body').classList.remove('body--scrolled')
  }
})

// Accordion

for (let accordionitem of document.querySelectorAll('.accordion__item')) {
  accordionitem.querySelector('.accordion__item-title').addEventListener('click', () => {
    accordionitem.classList.toggle('accordion__item--open')
  })
}


// Scale Animation for DMC-Intro

if(document.querySelector('.dmcpage__intro-background')) {
  window.addEventListener('scroll', () => {
    let scaleValue = 1 + window.scrollY / window.innerHeight * .25
    document.querySelector('.dmcpage__intro-background').style.transform = 'scale(' + scaleValue + ')'
  })
}

// Scroll-Indicator

if(document.querySelector('.scrollindicator')) {
  let indicator = document.querySelector('.scrollindicator #dot')

  let curve = document.querySelector('.scrollindicator #curve')
  let curveLength = curve.getTotalLength()

  let progress = 0

  let point = 0;


  let transformIndicator = () => {
    progress =  window.scrollY / (document.body.clientHeight - window.innerHeight)
    point = curve.getPointAtLength(progress * curveLength);
    indicator.setAttribute("transform", `translate(${point.x - 4}, ${point.y - 4})`);
  }

  document.addEventListener('DOMContentLoaded', transformIndicator())
  window.addEventListener('scroll', () => {
    transformIndicator()
  })
}


// AOS - Initialize AOS Library

AOS.init({
  duration: 500,
  easing: 'ease-in-out-quart',
  once: true,
  anchorPlacement: 'top-bottom'
});

